var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellemoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.2 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC83D",
    stroke: "#000000",
    strokeWidth: 2,
    d: "M28 13c0 11 5 10 5 15 0 0 0 2-2 2H5c-2 0-2-2-2-2 0-5 5-4 5-15C8 7.478 12.477 3 18 3s10 4.478 10 10z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC83D",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 18,
    cy: 4.2,
    r: 3.4,
    strokeDasharray: "11.58 9.5",
    strokeDashoffset: 11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    stroke: "#000000",
    strokeWidth: 2,
    d: "M18 34c2.209 0 4-1.791 4-4h-8c0 2.209 1.791 4 4 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellemoji);
export default __webpack_public_path__ + "static/media/bellemoji.1aff8fbd94306c9fbcaeb7d760cc5329.svg";
export { ForwardRef as ReactComponent };